import React, { memo, forwardRef } from "react";
const SvgNewton1Stderivative = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={11} y={11} fill="#DBDBDB" rx={2} />
      <circle cx={16} cy={9} r={1} fill="#717171" />
    </svg>
  );
});
SvgNewton1Stderivative.displayName = "SvgNewton1Stderivative";
const MemoForwardRef = memo(SvgNewton1Stderivative);
export default MemoForwardRef;
